import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

export function formatAddressQuery(address) {
  return [
    address?.street_address1,
    address?.street_address2,
    address?.city,
    address?.state,
    address?.postal_code,
    address?.country,
  ]
    .map((v) => String(v || '').trim())
    .filter(Boolean)
    .join(', ');
}

function component(result, type, short = false) {
  const match = result?.address_components?.find((c) => c.types?.includes(type));
  return short ? match?.short_name : match?.long_name;
}

export async function findAddressCandidates(address) {
  const query = formatAddressQuery(address);
  if (!query) return [];
  const results = await geocodeByAddress(query);
  return Promise.all(
    results.map(async (r) => ({
      placeId: r.place_id,
      formattedAddress: r.formatted_address,
      partialMatch: Boolean(r.partial_match),
      coordinates: await getLatLng(r),
      result: r,
    })),
  );
}

export function applyGoogleCandidate(address, candidate) {
  const lat = Number(candidate?.coordinates?.lat);
  const lng = Number(candidate?.coordinates?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    throw new Error('Google did not return valid coordinates for this address.');
  }
  const res = candidate.result;
  const streetNumber = component(res, 'street_number') || '';
  const route = component(res, 'route') || '';
  return {
    ...address,
    street_address1: [streetNumber, route].filter(Boolean).join(' ') || address.street_address1,
    city: component(res, 'locality') || component(res, 'postal_town') || component(res, 'administrative_area_level_2') || address.city,
    state: component(res, 'administrative_area_level_1', true) || address.state,
    postal_code: component(res, 'postal_code') || address.postal_code,
    country: component(res, 'country', true) || address.country,
    latitude: lat,
    longitude: lng,
  };
}
